// Headline summary tile used in the page KPI rows (User Management, Alerts).
// `tone` tints the value + icon badge (green / amber); `icon` optionally shows a
// rounded badge on the right for a more dashboard-like feel.
const TONE_VALUE = {
  green: 'text-green-600 dark:text-green-400',
  amber: 'text-amber-600 dark:text-amber-400',
  red: 'text-red-600 dark:text-red-400',
  slate: 'text-slate-500 dark:text-slate-400',
};
const TONE_BADGE = {
  green: 'bg-green-100 text-green-600 dark:bg-green-500/15 dark:text-green-300',
  amber: 'bg-amber-100 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300',
  red: 'bg-red-100 text-red-600 dark:bg-red-500/15 dark:text-red-300',
  slate: 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400',
};

export function StatTile({ label, value, tone, icon }) {
  const valueCls = TONE_VALUE[tone] || 'text-navy-800 dark:text-slate-100';
  const badgeCls = TONE_BADGE[tone] || 'bg-brand/10 text-brand dark:bg-brand/20 dark:text-brand-light';
  return (
    <div className="flex items-center justify-between gap-3 rounded-2xl bg-white/70 px-5 py-4 shadow-sm ring-1 ring-slate-900/5 dark:bg-white/5 dark:ring-white/10">
      <div className="min-w-0">
        <div className="text-xs font-medium uppercase tracking-wide text-slate-400 dark:text-slate-500">{label}</div>
        <div className={`mt-1 text-2xl font-semibold ${valueCls}`}>{value}</div>
      </div>
      {icon && (
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${badgeCls}`}>{icon}</span>
      )}
    </div>
  );
}
